<template>
  <rs-side-panel ref="sidePanel">
    <template slot="header">Fatura Ödeme</template>
    <template slot="body">
      <v-form ref="form" @submit.prevent="handleFormSubmit">
        <p>
          <router-link
            :to="{
              name: 'expenses.invoices.edit',
              params: { id: originalData.invoice_id },
            }"
          >
            Faturayı göster
          </router-link>
        </p>
        <v-row cols="12" dense>
          <v-col cols="12" sm="6">
            <rs-datepicker
              :label="$t('labels.date')"
              v-model="formData.collected_on"
              :rules="disabled ? [] : [rules.required]"
              :disabled="disabled"
              required
            />
          </v-col>

          <v-col cols="12" sm="6">
            <rs-money-field
              v-model="formData.amount"
              :rules="
                disabled || amountDisabled
                  ? []
                  : [
                      rules.required,
                      rules.min(formData.amount, 0.01),
                      rules.max(formData.amount, totalRemaining),
                    ]
              "
              :disabled="disabled || amountDisabled"
              :hint="`Kalan tutar: ${numberToLocaleFormat(totalRemaining)}₺`"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <rs-select-collecting
              label="Ödeme Yeri"
              :rules="[rules.required]"
              :bank-account-id.sync="formData.bank_account_id"
              :safe-id.sync="formData.safe_id"
              required
              :readonly="disabled"
              :filled="disabled"
              can-pay
              is-active
            />
          </v-col>

          <v-col cols="12" sm="6">
            <rs-textarea
              label="Açıklama"
              v-model="formData.description"
              :readonly="disabled"
              :filled="disabled"
              :rules="[rules.maxLength(formData.description, 1000)]"
            />
          </v-col>
        </v-row>

        <rs-form-buttons
          :is-loading="isLoading"
          @cancel="hide()"
          @submit.prevent="handleFormSubmit"
          hide-submit
          :hide-save-close="disabled"
        />
      </v-form>
    </template>
  </rs-side-panel>
</template>

<script>
import hasForm from "@/view/mixins/hasForm";

export default {
  name: "InvoicePaymentForm",
  mixins: [hasForm],
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  computed: {
    totalAmount() {
      if (!this.invoice || !this.invoice.items || !this.invoice.items.length) {
        return 0;
      }

      let totalAmount = 0;

      this.invoice.items.forEach(
        (item) => (totalAmount += parseFloat(item.amount))
      );

      return totalAmount;
    },
    totalPayment() {
      if (
        !this.invoice ||
        !this.invoice.payments ||
        !this.invoice.payments.length
      ) {
        return 0;
      }

      let totalAmount = 0;

      this.invoice.payments.forEach(
        (item) => (totalAmount += parseFloat(item.amount))
      );

      return totalAmount;
    },
    totalRemaining() {
      const amount = (this.totalAmount * 100 - this.totalPayment * 100) / 100;

      return amount;
    },
  },
  data() {
    return {
      id: null,
      amountDisabled: false,
      disabled: false,
    };
  },
  methods: {
    show(id, amount, disabled) {
      this.id = null;
      this.amountDisabled = false;
      this.formData = {
        collected_on: new Date().toJSON().split("T")[0],
        bank_account_id: null,
        safe_id: null,
        description: null,
        amount: amount || null,
      };

      if (amount) {
        this.amountDisabled = true;
      }

      if (disabled) {
        this.disabled = true;
      }

      if (id) {
        this.id = id;
        this.load();
      }

      this.$nextTick(() => {
        this.$refs.sidePanel.show();
      });
    },
    load() {
      if (this.isLoading || !this.id) {
        return false;
      }

      this.isLoading = true;

      this.$api
        .query(`expense/payments/${this.id}`)
        .then((response) => {
          this.loadData(response);
          document.getElementsByClassName("formatted-text")[0].innerHTML =
            this.numberToLocaleFormat(this.formData.amount);
        })
        .catch((error) => this.handleError(error))
        .finally(() => {
          this.isLoading = false;
        });
    },
    hide() {
      this.formData = {};
      this.$refs.sidePanel.hide();
    },
    handleCancelClick() {
      this.hide();
    },
    handleFormSubmit(event) {
      if (this.isLoading || !this.$refs.form.validate()) {
        this.$toast.error("Lütfen tüm gerekli alanları doldurunuz");
        return false;
      }

      this.isLoading = true;

      const formData = Object.assign({}, this.formData);
      formData.invoice_id = this.invoice.id;

      if (!this.id) {
        formData.invoice_id = this.invoice.id;
      }

      if (this.id) {
        this.$api
          .put(`expense/payments/${this.id}`, formData)
          .then(() => {
            this.$toast.success("Kaydedildi");
            this.$emit("saved", this.formData);
            if (event && event.closeOnSave) {
              this.hide();
              return;
            }
            setTimeout(() => this.load(), 100);
          })
          .catch((error) => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$api
          .post(`expense/invoices/${this.invoice.id}/payments`, formData)
          .then((response) => {
            this.$toast.success("Kaydedildi");
            this.$nextTick(() => this.$emit("saved", this.formData));
            if (event && event.closeOnSave) {
              this.hide();
              return;
            }
            this.id = response.data.data.id;
            setTimeout(() => this.load(), 100);
          })
          .catch((error) => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>
